<template>
  <v-card>
    <v-card-title class="primary">
      <span class="headline white--text">
        {{ $t('editTicketBook')}}
      </span>
      <v-spacer/>
      <Icon
        iconColor="white"
        icon="mdi-close"
        :small="false"
        large
        :tooltipText="$t('close')"
        @icon-clicked="$emit('close')"/>
    </v-card-title>
    <v-card-text>
      <FormWrapper
      :buttonText="$t('save')"
      @submit="$emit('edit-ticket-book', ticketBook)">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="ticketBook.name"
                :label="$t('name')"
                color="black"
                required
                maxLength="64"
              />
            </v-col>
          </v-row>
        </v-container>
        <template #right-action v-if="ticketBook.status !== TicketBookStatus.InUse.value">
          <v-row class="mr-3">
            <v-col cols="12">
              <v-select
                v-model="ticketBook.status"
                item-text="name"
                item-value="value"
                :items="statuses"
              />
            </v-col>
          </v-row>
        </template>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import { TicketBookStatus } from '@/utils/Enumerations'
export default {
  name: 'TicketBookEditor',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue')
  },

  props: {
    propTicketBook: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    TicketBookStatus,
    ticketBook: undefined
  }),

  created () {
    this.ticketBook = { ...this.propTicketBook }
  },

  computed: {
    statuses () {
      return [TicketBookStatus.Available, TicketBookStatus.Inactive]
    }
  }
}
</script>
